// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@conklin/App/Store/Reducers";
import { parseBoolean } from "@conklin/XDL/Utilities";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    if (!props.cartToUpdate) {
        return;
    }
    const state = props.getState() as CustomAppState;

    props.apiParameter.cart = {
        ...props.apiParameter.cart,
        properties: {
            ...props.apiParameter.cart.properties,
            ...(props.apiParameter.cart.fulfillmentMethod === FulfillmentMethod.PickUp
                ? {
                      pickUpWhenComplete: state.xCheckout.pickupWhenComplete === "true",
                  }
                : {
                      shipWhenComplete: state.xCheckout.shipWhenComplete === "true",
                  }),
            ...(state.xCheckout.taxExempt
                ? {
                      isTaxExempt: true,
                      taxExemptCertificateNumber: state.xCheckout.taxExemptCertificateNumber,
                  }
                : {}),
        } as any,
        cartLines: props.apiParameter.cart?.cartLines?.filter(line => !parseBoolean(line.properties?.isQuote)),
    };

    delete props.apiParameter.cart.properties.maskedCreditCardDetails;
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
